module.exports = __webpack_public_path__ + "img/palmas-room-5.1636c9fa.jpg";